import React from "react";
import { View, Text } from "react-native";
import { globalFontStyle } from "../assets";
import Colors from "../assets/Color/Colors";
import { isMobile } from "../utils/commonMethods";
import FormTextLabel from "./FormTextLabel";
import {globalConfigurableData, GlobalScreens} from "../utils/globalConstant";

const DisclaimerText = ({ text = "" }) => {
  return (
    <View
      style={
        isMobile()
          ? {
              flex: 0,
              marginTop: 20,
              padding: 10,
              position: "absolute",
              bottom: 100,
              left: 20,
              right: 20,
              borderRadius: 15,
              paddingHorizontal: 15,
              paddingVertical: 10,
              backgroundColor: GlobalScreens.AddMoney.disclaimerBgColor,
            }
          : {
              marginTop: 20,
              borderRadius: 15,
              paddingHorizontal: 15,
              paddingVertical: 10,
              backgroundColor: GlobalScreens.AddMoney.disclaimerBgColor,
            }
      }
    >
      <FormTextLabel
        labelStyles={{
          ...globalFontStyle.appFontSubText,
          color: globalConfigurableData.secondaryTextColor1,
          paddingVertical: 5,
          textAlign: "center",
        }}
        label={text}
      />
    </View>
  );
};

export default DisclaimerText;
